export default {
  large: [

    {
      sectionType: 'subsections',

      data: {
        color: 'offBlackOnOffWhite',
        sections: [
          {
            full: {
              component: 'flex-block',
              data: {
                blockModifiers: ['endMargin','alignCenter'],
                headerSize: 'large',
                header1: 'Create&nbsp;curated shopping experiences within your content.',
                text1: "<p>Spotin’s content commerce solutions features friction-free shopping experiences in any digital content - without links, redirections or page reloads. </p>",
                component3: {
                  type: 'animation',
                  data: {
                    loop: true,
                    autoplay: true,
                    // blockModifiers: ['endMargin'],
                    blockModifiers: ['bringToFront','450px','mobileOffSetMinus90'],
                    src: "Shop_box_animation_product_page.json",
                  }
                }
              },
            },
          }
        ]
      },
    },

    {
      sectionType: 'subsections',

      data: {
        color: 'offWhiteOnOffBlack',
        sections: [
          {
            full: {
              component: 'flex-block',
              data: {
                columns: 3,
                mobileHeaderTop: true,
                blockModifiers: ['startMargin','endMargin','alignCenter'],
                component1: {
                  type: 'animation',
                  data: {
                    blockModifiers: ['mobileTopMargin','noBottomMargin','noMaxWidthHeight'],
                    loop: true,
                    autoplay: true,
                    src: "Demoscroll_desktop.json",
                  },
                },
                header3: 'Make&nbsp;any content&nbsp;piece a&nbsp;shopping experience',
                text3: `
                  <p>Spotin’s content commerce solutions allow truly seamless shopping experiences within your content.</p>
                  <p>Writing about a book? Give your visitors the opportunity to buy it on the spot, without having to leave your site!</p>
                  <p>With Spotin’s you can enable commerce from any text, image or video on your site.</p>
                  <p>Have a look at <a href="https://demo.spotin.com" style="text-decoration: underline;">our demo</a> or read more about the <a style='text-decoration: underline;' href='/commercemanager'>Spotin Commerce Manager</a> tool, and discover the many ways to use Spotin’s content commerce solutions.</p>
                `,
              },
            },
          }
        ]
      },
    },

    {
      sectionType: 'subsections',

      data: {
        color: 'offBlackOnOffWhite',
        sections: [
          {
            full: {
              component: 'flex-block',
              data: {
                blockModifiers: ['headerMargin'],
                header1: 'Features&nbsp;for in-content commerce',
                text2: "<p>Spotin's features are built to synergize and enable commerce. From adding shoppability to highlighted products to cross-sell, by seamless access to complete product cataloges from seller(s) with <a href='/shop' style='text-decoration: underline;'>the Shop</a>.</p><p>Spotin's commerce solutions work with your exiting content, and can also be used e.g. with existing image carousels. All with just a few clicks using our <a style='text-decoration: underline;' href='/commercemanager'>Spotin Commerce Manager</a> tool.</p>",
              }
            },
          }
        ]
      },
    },

    {
      sectionType: 'subsections',

      data: {
        color: 'offBlackOnOffWhite',
        blockModifiers: ['noPaddingTop'],
        sections: [
          {
            top: {
              component: 'flex-block',
              data: {
                columns: 2,
                header2: "Spots",
                text2: "Spots make all products discovered in an image buyable. Spots are direct access sales channels to brands. Just by clicking on a Spot customers get all the product information (images, price, stock availability, shopping information and terms and conditions) directly from the seller, and can shop right on the spot.</p><p>The image can be an editorial image, or an image provided from the seller. A single image can contain several spots, also from different sellers.",
              }
            },
            bottom: {
              component: 'flex-block',
              data: {
                columns: 3,
                blockModifiers: ['noColumnMargin','alignCenter'],
                img2: {
                  blockModifiers: ['noMargin'],
                  src: 'swedish_stockings.png',
                  alt: 'Spots demo image',
                },
              }
            }
          }
        ]
      },
    },

    {
      sectionType: 'subsections',

      data: {
        color: 'offBlackOnOffWhite',
        sections: [
          {
            top: {
              component: 'flex-block',
              data: {
                columns: 2,
                header2: "Buy buttons",
                text2: "Buy buttons make any content into an image-based sales channel and are suitable for images that highlights a single product.",
              }
            },
            bottom: {
              component: 'flex-block',
              data: {
                columns: 3,
                blockModifiers: ['noColumnMargin','maxWidth500'],
                img2: {
                  blockModifiers: ['noMargin'],
                  src: 'bok_amor_towles.png',
                  alt: 'Buy button demo image',
                },
              }
            }
          }
        ]
      },
    },

    {
      sectionType: 'subsections',

      data: {
        color: 'offBlackOnOffWhite',
        blockModifiers: ['centerBottom'],
        sections: [
          {
            top: {
              component: 'flex-block',
              data: {
                columns: 2,
                header2: "Direct links",
                text2: "<p>You can add direct links to products (or <a href='/shop' style='text-decoration: underline;'>the Shop</a>) without page reload just by copy/pasting the address to the product on your page, or by using the Spotin frontend API.</p><p>(If you also have <a href='/shop' style='text-decoration: underline;'>the Shop</a> you may link to a seller or brand from the text, or add a button to open your shop.)</p>",
              }
            },
            bottom: {
              component: 'flex-block',
              data: {
                headerSize: 'large',
                blockModifiers: ['centerAlignText','noMargin'],
                header1: `Like&nbsp;here,&nbsp;where you&nbsp;can <a onClick="spotinAPI.openProductFromURL('https://www.spotin.com/incontent#/sp?p=45130&v=620120')" style="text-decoration: underline; color: #0048FF;">shop&nbsp;the same&nbsp;📖&nbsp;as&nbsp;above</a>`,
              }
            }
          }
        ]
      },
    },

    {
      sectionType: 'subsections',

      data: {
        color: 'offBlackOnOffWhite',
        blockModifiers: ['centerBottom'],
        sections: [
          {
            top: {
              component: 'flex-block',
              data: {
                columns: 2,
                header2: "Embedded shoppable blocks",
                text2: `
                  <p>In addition to adding commercial features to your existing content, Spotin offers several ways of embedding commercial solutions that are shown inline with (and complements) your content.</p>
                  <p>With Spotin’s on-site UI editors/content creators can create curated lists to showcase the relevant products directly on the site.</p>
                `,
              }
            },
            bottom: {
              component: 'html-block',
              data: {
                // blockModifiers: ['endMargin'],
                // html: '<spotin-block data-blockid="curated-c09da1c7-bdd5-4766-ae22-1d3198d70c20"></spotin-block>' // Dev
                html: `<spotin-block data-blockid="curated-8986e03a-5264-4d27-908a-d7cd8573f913"></spotin-block>`
              }
            },
          }
        ]
      },
    },

    {
      sectionType: 'subsections',

      data: {
        color: 'offBlackOnOffWhite',
        blockModifiers: ['centerBottom','noPaddingTop'],
        sections: [
          {
            top: {
              component: 'flex-block',
              data: {
                columns: 3,
                blockModifiers: ['noMargin','centerAlignText','boldText'],
                text2: '(or why not embed a curated list created in your shop, directly in your content)',
              }
            },
            bottom: {
              component: 'html-block',
              data: {
                // blockModifiers: ['endMargin'],
                html: `<spotin-block data-blockid="curated-7a5d83b0-6987-47e9-897f-5320f5a7a14d"></spotin-block>`,
              }
            }
          }
        ]
      },
    },


    {
      sectionType: 'subsections',

      data: {
        color: 'offBlackOnSand',
        blockModifiers: ['centerBottom'],
        sections: [
          {
            full: {
              component: 'flex-block',
              data: {
                columns: 2,
                header2: "Customisable product display",
                text2: "<p>Select how to display product pages in different layouts using our templates. Select between side panel view for keeping the background content on screen or full size for a more full on e-com experience.</p>",
              }
            },
          }
        ]
      },
    },


    {
      sectionType: 'subsections',

      data: {
        color: 'offBlackOnSand',
        blockModifiers: ['center','minTopPadding'],
        sections: [
          {
            full: {
              component: 'flex-block',
              columns: 2,
              data: {
                blockModifiers: ['alignCenter','endMargin'],
                component1: {
                  type: 'animation',
                  data: {
                    loop: true,
                    autoplay: true,
                    src: "product_page_full_width_Desktop.json",
                    caption: 'Full width' 
                  }
                },
                component3: {
                  type: 'animation',
                  data: {
                    loop: true,
                    autoplay: true,
                    src: "product_page_side_panel_Desktop.json",
                    caption: 'Side panel'      
                  }
                }
              }
            }
          }
        ]
      },
    },


    {
      sectionType: 'subsections',

      data: {
        color: 'offWhiteOnOffBlack',
        sections: [
          {
            full: {
              component: 'flex-block',
              data: {
                blockModifiers: ['endMargin','alignCenter'],
                header1: 'One&nbsp;line&nbsp;of &#60;code&#62; and you’re&nbsp;up&nbsp;& running',
                text1: 'After creating your account with Spotin you’ll recieve a single script-line to add to your site. Once added to your site you can start using Spotin and start selling right away.',
                component2: {
                  type: 'animation',
                  data: {
                    blockModifiers: ['mobileTopMargin','noBottomMargin'],
                    loop: true,
                    autoplay: true,
                    src: "OneLineOfCode.json",
                  }
                },
              }
            },
          }
        ]
      },
    },


    {
      sectionType: 'subsections',

      data: {
        color: 'offBlackOnSand',
        sections: [
          {
            full: {
              component: 'flex-block',
              data: {
                blockModifiers: ['endMargin','alignCenter'],
                header1: 'Perfect&nbsp;for&nbsp;selling on&nbsp;social&nbsp;media',
                text1: '<p>With Spotin\'s social sharing features you can promote your shoppable content from anywhere where you can add a link.</p><p>Instagram stories, Bio links, Newsletters, Tweets, Facebook, TikTok, LinkedIn, YouTube, Snapchat and more. Instead of monetizing traffic from your content (and lose your readers), you can now drive sales and traffic to your content at the same time.</p>',
                component3: {
                  type: 'animation',
                  data: {
                    blockModifiers: ['bringToFront','350px','mobileOffSetMinus50','mobileTopMargin'],
                    loop: true,
                    autoplay: true,
                    src: "PerfectForSome.json",
                  }
                },
              }
            },
          }
        ]
      },
    },

    {
      sectionType: 'subsections',

      data: {
        color: 'offWhiteOnBlue',
        sections: [
          {
            top: {
              component: 'flex-block',
              data: {
                header1: 'A&nbsp;ton&nbsp;of&nbsp;features<br>to&nbsp;drive&nbsp;sales',
              }
            },
            bottom: {
              component: 'flex-block',
              data: {
                blockModifiers: ['smallHeader','smallText','bottomMarginOnLastColumn'],
                header1: 'No links, redirects or page (re)loads',
                text1: 'Avoid loading new pages (even site). Convert your visitors to paying customers with a seamless experience from content to commerce.',
                header2: 'One bag and one checkout',
                text2: 'Add products from different sellers, even across different sites, and complete order with a single checkout.',
                header3: 'Payment solutions included',
                text3: 'Apple pay, Google Pay, Visa, Mastercard and the most common cards, and Klarna. We add more payment solutions all the time and configure payment options depending on customer preferences for different markets.',
              }
            }
          }
        ]
      },
    },


    {
      sectionType: 'subsections',

      data: {
        color: 'offWhiteOnBlue',
        blockModifiers: ['noPaddingTop'],
        sections: [
          {
            top: {
              component: 'flex-block',
              data: {
                blockModifiers: ['smallHeader','smallText','bottomMarginOnLastColumn'],
                header1: 'International sales',
                text1: 'Reach new markets and new customers with Spotin’s solutions: language configurable/detectable by site or region, automatic handling of seller shipping countries, cross-market VAT information to customers, prices in the right currency from specific seller warehouse, and currency conversion if prices in local currency is missing from seller.',
                header2: 'Site-specific campaigns',
                text2: 'No need for discount codes with site specific campaign prices. Sellers may set specific prices e.g. for specific products or categories for specific sites and time periods with Spotin. This enable content makers and sellers to work together on site specific campaigns. Spotin automatically keeps track of campaigns and highlight these in the UI.',
                header3: 'Always up to date',
                text3: 'Always the everything from selling parties, always the latest, with live-updated stock levels and prices for your market. New drops, sales or something sold out? Spotin always keeps your commerce updated.',
              },
            },
            bottom: {
              component: 'flex-block',
              data: {
                blockModifiers: ['endMargin','smallHeader','smallText','bottomMarginOnLastColumn'],
                header1: 'Related&nbsp;sales, seamless&nbsp;and built&nbsp;in',
                text1: 'Sell related products with spots within sellers’ product images, by automatic recommendations, or from discovering more from the seller (or author). Spotin also enable seamless related sales which was previously a strong argument for redirecting customers somewhere else.',
                header2: 'Pre-order and backorder',
                text2: 'Pre-order products before they are released (e.g. print on demand or soon to be released book, or a garment from the a runway image). We also support backorder of products if you do. Spotin also highlights this information to the customer to drive sales and inform users of delayed delivery.',
                header3: 'Branded design (optional)',
                text3: 'We can brand your commerce solution with Spotin so that it fits with your identity. We can add your logo, fonts, color schemes and styles to align and enhance the customer experience with your brand’s identity.',
              }
            }
          }
        ]
      },
    },


    {
      sectionType: 'subsections',

      data: {
        color: 'offBlackOnSand',
        sections: [
          {
            top: {
              component: 'flex-block',
              data: {
                // blockModifiers: ['endMargin'],
                header1: 'Spotin Commerce Manager',
                text2: '<p>With the Commerce Manager you can create and manage all commercial solutions with Spotin directly on your site. Add on-site shopping solutions and manage your shop with an easy to use UI.</p><p>When you sign in with Spotin (on your site) the Commerce Manager appears as a layer on top of your site.</p>',
                link2: {
                  linkText: 'Know more',
                  route: 'commercemanager',
                },
              }
            },
            bottom: {
              component: 'flex-block',
              data: {
                // blockModifiers: ['endMargin'],
                component2: {
                  type: 'animation',
                  data: {
                    blockModifiers: ['maxWidthHeight800'],
                    loop: true,
                    autoplay: true,
                    src: "ContentManager.json",
                  }
                },
              }
            },
          }
        ]
      },
    },


    {
      sectionType: 'subsections',

      data: {
        color: 'blueOnSand',
        sections: [
          {
            top: {
              component: 'flex-block',
              data: {
                header1: 'Other products & solutions'
              }
            },
            bottom: {
              component: 'Related',
              data: {
                buttons: [
                  {
                    icon: 'arrowUpRight',
                    label: 'Spotin Commerce Manager',
                    blockModifiers: ['alignLabelLeft', 'alignLabelTop'],
                    path: 'commercemanager',
                  },
                  {
                    icon: 'arrowUpRight',
                    label: 'Virtual marketplace',
                    blockModifiers: ['alignLabelLeft', 'alignLabelTop'],
                    path: 'shop',
                  },
                  {
                    icon: 'arrowUpRight',
                    label: 'Bag & checkout',
                    blockModifiers: ['alignLabelLeft', 'alignLabelTop'],
                    path: 'checkout',
                  }
                ],
              }
            }
          }
        ]
      },
    },

  ],
};



// WEBPACK FOOTER //
// ./pages/Incontent.js